import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({
  name: 'tableFilter'
})
@Injectable()
export class TableFilterPipe implements PipeTransform {
  transform(
      items: any[],
      name: string,
      phone: string,
      carNumber: string,
      carrier: string,
      orderNumber: string,
      requestNumber: string,
      tracking: string,
      plantName: string,
      clientName: string,
      address: string,
      deliveryStatus: string
    ): any[] {
      if (items && items.length){
        return items.filter(item => {
          if (name && item.driver_name.toLowerCase().indexOf(name.toLowerCase()) === -1){
              return false;
          }
          if (phone && item.driver_phone.toLowerCase().indexOf(phone.toLowerCase()) === -1){
              return false;
          }
          if (carNumber && item.vehicle_info.toLowerCase().indexOf(carNumber.toLowerCase()) === -1){
            return false;
          }
          if (carrier && item.carrier.toLowerCase().indexOf(carrier.toLowerCase()) === -1){
            return false;
          }
          if (orderNumber && item.shipment_id.toString().toLowerCase().indexOf(orderNumber.toLowerCase()) === -1) {
            return false;
          }
          if (requestNumber && item.request_id.toString().toLowerCase().indexOf(requestNumber.toLowerCase()) === -1) {
            return false;
          }
          if (tracking && item.tracking.toString().toLowerCase().indexOf(tracking.toLowerCase()) === -1) {
            return false;
          }
          if (plantName && item.plant_name.toString().toLowerCase().indexOf(plantName.toLowerCase()) === -1) {
            return false;
          }
          if (clientName && item.client_name.toString().toLowerCase().indexOf(clientName.toLowerCase()) === -1) {
            return false;
          }
          if (address && item.address.toString().toLowerCase().indexOf(address.toLowerCase()) === -1) {
            return false;
          }
          if (deliveryStatus && item.delivery_status.toString().toLowerCase().indexOf(deliveryStatus.toLowerCase()) === -1) {
            return false;
          }

          return true;
       });
    }
    else {
      return items;
    }
  }
}
